module.exports = __webpack_public_path__ + "static/media/mobile_child_usage1.e0c3f6e7.png";